import Keycloak from 'keycloak-js';
import { setRumUser } from 'app/lib/rum';

export type Authentication = { username?: string; jwt?: string };

let pendingAuthentication: Promise<Authentication> | null = null;

async function authenticate(): Promise<Authentication> {
    const accessToken = new URLSearchParams(window.location.search).get('accessToken') ?? undefined;
    const keycloak = new Keycloak('/config/keycloak');

    const authenticated = await keycloak.init({
        onLoad: 'login-required',
        checkLoginIframe: false,
        token: accessToken
    });
    if (!authenticated) {
        throw new Error('keycloak: not authenticated despite login prompt');
    }

    const userInfo = await keycloak.loadUserInfo().catch(() => {
        throw new Error('keycloak: failure at getting user information via loadUserInfo()');
    });
    setRumUser(userInfo);

    window.europa ??= {};
    window.europa.keycloak = keycloak;

    return { username: userInfo.preferred_username, jwt: keycloak.token };
}

export function startAuthentication() {
    pendingAuthentication = authenticate();
    return pendingAuthentication;
}

export function takeAuthentication() {
    const authentication = pendingAuthentication ?? authenticate();
    pendingAuthentication = null;
    return authentication;
}
